import styled from 'styled-components';
import Colors from "../../themes/Colors";
import Fonts from "../../themes/Fonts";
import { fadeIn } from '../Common/CommonStyles';

export const Button = styled.button.attrs(props => ({
  'data-testid': props.testid
}))`
  background-color: ${(props) =>
    props?.backGroundColor || Colors.primaryPrimera};
  color: ${(props) => props?.textColor || Colors.white};
  font-family: ${(props) => props.font || Fonts.familyVerlag};
  font-weight: ${(props) => props.weight || "normal"};
  font-size: 16px;
  padding: 10px 20px;
  border: ${(props) => props.border || "none"};
  border-radius: 25px;
  cursor: pointer;
  width: ${(props) => props.width || ""};
  height: ${(props) => props.height || "40px"};
  transition: background-color 0.3s, color 0.3s;
  &:hover {
    background-color: ${(props) => props?.hoverColor || Colors.primaryPrimera};
    color: ${(props) => props?.hoverTextColor || Colors.white};
  }

  &:focus {
    outline: none;
  }

  &:active {
    background-color: ${(props) =>
      props?.backGroundColor || Colors.primaryPrimera};
  }

  &:disabled {
    background-color: ${(props) => props?.disabledBgColor || Colors.grey};
    color: ${(props) => props?.disabledTextColor || Colors.grayFont};
    border: ${(props) => props?.disabledBorder || `1px solid ${Colors.grey}`};
    cursor: not-allowed;
    opacity: 0.6;
  }

  &:disabled:hover {
    background-color: ${(props) => props?.disabledBgColor || Colors.grey};
    color: ${(props) => props?.disabledTextColor || Colors.grayFont};
  }

  @media (max-width: 844px) {
    font-size: 14px;
    width: 290px;
    height: auto;
    animation: ${fadeIn} 0.5s ease-in;
  }

  @media (max-width: 320px) {
    animation: ${fadeIn} 0.5s ease-in;
    width: 200px;
  }
`;